import React, { useState, useEffect } from 'react';
import { Card, Button, Space, Typography, Divider } from 'antd';

const { Text, Title } = Typography;

const DebugConsole = () => {
  const [logs, setLogs] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  
  // 替换原始的console方法以捕获日志
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return;
    
    const originalLog = console.log;
    const originalError = console.error;
    const originalWarn = console.warn;
    
    console.log = (...args) => {
      setLogs(prev => [...prev, { type: 'log', content: args, time: new Date() }]);
      originalLog(...args);
    };
    
    console.error = (...args) => {
      setLogs(prev => [...prev, { type: 'error', content: args, time: new Date() }]);
      originalError(...args);
    };
    
    console.warn = (...args) => {
      setLogs(prev => [...prev, { type: 'warn', content: args, time: new Date() }]);
      originalWarn(...args);
    };
    
    return () => {
      console.log = originalLog;
      console.error = originalError;
      console.warn = originalWarn;
    };
  }, []);
  
  const clearLogs = () => setLogs([]);
  
  if (process.env.NODE_ENV !== 'development') return null;
  
  return (
    <div style={{ 
      position: 'fixed', 
      bottom: isExpanded ? 0 : -300,
      left: 0,
      right: 0,
      background: '#f0f2f5',
      transition: 'bottom 0.3s',
      zIndex: 1000,
      boxShadow: '0 -2px 8px rgba(0,0,0,0.15)'
    }}>
      <div style={{ 
        padding: '8px 16px', 
        background: '#001529', 
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer'
      }} onClick={() => setIsExpanded(!isExpanded)}>
        <Text strong style={{ color: 'white' }}>调试控制台 ({logs.length})</Text>
        <Text style={{ color: 'white' }}>{isExpanded ? '点击关闭' : '点击展开'}</Text>
      </div>
      
      {isExpanded && (
        <div style={{ height: '300px', overflow: 'auto', padding: '16px' }}>
          <Space style={{ marginBottom: '16px' }}>
            <Button size="small" onClick={clearLogs}>清除日志</Button>
          </Space>
          
          <div>
            {logs.map((log, index) => (
              <div key={index} style={{ marginBottom: '8px' }}>
                <Text type={log.type === 'error' ? 'danger' : log.type === 'warn' ? 'warning' : undefined} style={{ fontSize: '12px' }}>
                  [{log.time.toLocaleTimeString()}] [{log.type.toUpperCase()}]
                </Text>
                <pre style={{ 
                  margin: '4px 0', 
                  padding: '8px', 
                  background: log.type === 'error' ? '#fff2f0' : log.type === 'warn' ? '#fffbe6' : '#f6f8fa',
                  borderRadius: '4px',
                  fontSize: '12px',
                  overflow: 'auto'
                }}>
                  {log.content.map(item => 
                    typeof item === 'object' ? JSON.stringify(item, null, 2) : String(item)
                  ).join(' ')}
                </pre>
                {index < logs.length - 1 && <Divider style={{ margin: '8px 0' }} />}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DebugConsole; 